import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f2232f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-display-mode" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-th-large" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-th" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-th-list" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["btn", { active: _ctx.displayMode === 'two-column' }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMode('two-column'))),
      "data-testid-two-column": "",
      "aria-label": _ctx.$t('search.two-column-view')
    }, _hoisted_4, 10, _hoisted_2),
    _createElementVNode("button", {
      class: _normalizeClass(["btn", { active: _ctx.displayMode === 'four-column' }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMode('four-column'))),
      "data-testid-four-column": "",
      "aria-label": _ctx.$t('search.four-column-view')
    }, _hoisted_7, 10, _hoisted_5),
    _createElementVNode("button", {
      class: _normalizeClass(["btn", { active: _ctx.displayMode === 'detailed' }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setMode('detailed'))),
      "data-testid-detailed": "",
      "aria-label": _ctx.$t('search.detailed-list-view')
    }, _hoisted_10, 10, _hoisted_8)
  ]))
}